import { NotificacionDTO, TipoNotificacion } from './header.models';

/* Notificación */
export class Notificacion {
  constructor(
    public id: number,
    public tipo: TipoNotificacion,
    public mensaje: string,
    public url: string | null,
    public leida: boolean,
    public fechaCreacion: string,
  ) {}

  /**
   * Crea un objeto Notificación a partir de los datos del API.
   * @param {NotificacionDTO} notificacion - La notificación como llega del API.
   * @returns {Notificacion} - El objeto Notificación creado.
   * @author Juan Corral
   */
  public static fromDTO(notificacion: NotificacionDTO): Notificacion {
    return new Notificacion(
      notificacion.id,
      notificacion.tipo,
      notificacion.mensaje,
      notificacion.url,
      notificacion.leida,
      notificacion.fecha_creacion,
    );
  }
}
